import React from 'react';

import { Form, Modal, notification } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useNotification } from 'segments/hooks';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { api, setLocalProduct, UpdateProductParams, useUpdateProductMutation } from 'features/products';

type FormData = UpdateProductParams;

interface Props {
  isModalOpen: boolean;
  handleCancel: () => void;
  data?: UpdateProductParams;
}

const EditProductModal = ({ isModalOpen, handleCancel, data }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [form] = Form.useForm<FormData>();
  const [update, { isSuccess, isError, isLoading, error }] = useUpdateProductMutation();

  useNotification({
    isSuccess,
    isError,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel(),
    error
  });

  const onFinish = (values: FormData) => {
    if (data?.isOnline) {
      update({ ...values, id: data?.id } as FormData);
    } else {
      setLocalProduct({ ...data, ...values });
      dispatch(api.util.invalidateTags(['ProductsList']));
      handleCancel();
      notification.success({
        message: t('notifications.success'),
        placement: 'top',
      });
    }
  };

  return (
    <Modal
      title={`${t('products.title.edit')} "${t(`products.items.${data?.name}`)}"`}
      open={isModalOpen}
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        initialValues={{ ...data }}
        onFinish={onFinish}
        autoComplete="off"
        className="edit-user__form"
      >
        <InputStr innputNumberProps={{ min: 1 }} type="price" />
        <SubmiteButton submiteText={t('user.edit-data')} isLoading={isLoading} />
      </Form>
    </Modal>
  );
};

export default EditProductModal;
